<div class='checkout mt-5 mb-5'>
    <div *ngIf="error" class="container">
        <app-errormessage
            [serverErrorMessage]="error.message"
            [errorMessageTranslationKey]="error.localizationKey">
        </app-errormessage>
    </div>

    <h2 [appTranslate]="'FinalizingRegistrationMessage'" style="text-align: center">We are finalizing your registration</h2>

    <div class="full-size-spinner-container">
        <app-spinner *ngIf="registrationInProgress"></app-spinner>
    </div>

</div>
